import dateAdapter from '@/helpers/dayjsAdapter';
import store from '@/store';
import { NEUTRAL_SENTIMENT, POSITIVE_SENTIMENT, NEGATIVE_SENTIMENT } from '@/assets/common/sentiments';
import feedItems from './feed-items';
import {
    BY_MOST_SHARES_VALUE,
    TOP_COUNTRIES_OPTION,
    TOP_LANGUAGES_OPTION,
    BY_MOST_COMMENTS_VALUE,
    BY_MOST_FOLLOWERS_VALUE,
    BY_TOTAL_ENGAGEMENT_VALUE
} from '@/assets/dashboard/widget-settings';

const { getters } = store;

const SYS_ADMIN_ROLE = getters['auth/SYS_ADMIN_ROLE'];
const ADMIN_ROLE = getters['auth/ADMIN_ROLE'];
const AGENT_ROLE = getters['auth/AGENT_ROLE'];
const GUEST_ROLE = getters['auth/GUEST_ROLE'];

const ruleTemplate = {
    entities: [
        {
            entity_type: 1,
            entity_id: 1
        }
    ],
    query: 'hide OR block OR "hide and block" OR hidden OR blocked',
    exclude_query: '',
    rule_type: 5,
    status_type: [1],
    identities: ['@ANYPROFILE'],
    label_ids: ['1']
};

export default {
    profiles: [
        {
            social_type: 1,
            username: 'someone',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 2,
            username: 'Instagramowy uzytkownik',
            photo_url: 'https://i.kym-cdn.com/entries/icons/facebook/000/031/015/cover5.jpg',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 3,
            username: 'Robercig Lewy',
            photo_url: 'https://babskiesprawy.pl/download/file.php?avatar=21756_1462801611.png',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 3,
            username: 'El Majczini',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 11,
            username: 'Leo Meśiu',
            photo_url: 'https://i.kym-cdn.com/entries/icons/facebook/000/031/015/cover5.jpg',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 11,
            username: 'Domino',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 16,
            username: '600th PR',
            created_at: '2022-04-15T12:13:50.000Z'
        },
        {
            social_type: 16,
            username: 'Intercomowiczówna',
            photo_url: 'https://babskiesprawy.pl/download/file.php?avatar=21756_1462801611.png',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 10,
            username: 'jony jony',
            photo_url: 'https://i.kym-cdn.com/entries/icons/facebook/000/031/015/cover5.jpg',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 8,
            username: 'Yahav Yahavowski',
            photo_url: 'https://i.kym-cdn.com/entries/icons/facebook/000/031/015/cover5.jpg',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 19,
            username: 'nice one',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 5,
            username: 'YT user',
            created_at: '2018-10-10T12:41:17.000Z'
        },
        {
            social_type: 5,
            username: 'YT another user',
            created_at: '2018-10-10T12:41:17.000Z'
        }
    ],

    profileItems: [
        {
            name: 'Footbal',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '4',
            socialType: 3,
            photo_url:
                'https://image.shutterstock.com/image-photo/word-example-written-on-magnifying-260nw-1883859943.jpg'
        },
        {
            name: 'Soccer',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '4',
            socialType: 3
        },
        {
            name: 'Chess',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '4',
            socialType: 3
        },
        {
            name: 'Laptops',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '3',
            socialType: 3
        },
        {
            name: 'Sport',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '3',
            socialType: 3
        },
        {
            name: 'Food',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '5',
            socialType: 11
        },
        {
            name: 'Games',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '6',
            socialType: 11
        },
        {
            name: 'Something',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'group',
            profileId: '5',
            socialType: 11,
            photo_url:
                'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTBwAo9q5FtWQKO_hKSmgkKkrMZZtirYph9xg&usqp=CAU'
        },
        {
            name: 'Page 1',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'page',
            profileId: '4',
            socialType: 3
        },
        {
            name: 'Page 2',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'page',
            profileId: '3',
            socialType: 3,
            photo_url: 'https://t4.ftcdn.net/jpg/03/16/68/69/360_F_316686992_OvCTP1wfazJhBeMrBBDUGooufSmj2O8G.jpg'
        },
        {
            name: 'Page 3',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'page',
            profileId: '3',
            socialType: 3
        },
        {
            name: 'Page 4',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'page',
            profileId: '5',
            socialType: 11
        },
        {
            name: '@1',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'ad',
            profileId: '4',
            socialType: 3
        },
        {
            name: '@2',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'ad',
            profileId: '4',
            socialType: 3
        },
        {
            name: '@3',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'ad',
            profileId: '4',
            socialType: 3
        },
        {
            name: '@4',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'ad',
            profileId: '3',
            socialType: 3
        },
        {
            name: '@5',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'ad',
            profileId: '3',
            socialType: 3
        },
        {
            name: 'channel one',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'channel',
            profileId: '12',
            socialType: 5
        },
        {
            name: 'channel 2',
            createdAt: '2018-10-10T12:41:17.000Z',
            type: 'channel',
            profileId: '12',
            socialType: 5
        }
    ],

    feedItems,

    users: [
        {
            email: 'sys_admin@aff.test',
            password: 'm5EcRb1tWy2000QLC@h6',
            createdAt: '2020-03-12T12:41:17.000Z',
            firstName: 'Sys',
            lastName: 'Admin',
            role: SYS_ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: true,
                    url_warning: false
                },
                security: {
                    two_factor_authentication: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'admin@aff.test',
            createdAt: '2020-03-12T12:41:17.000Z',
            password: 'm5EcRb1tWy2000QLC@h6',
            firstName: 'Admin',
            lastName: 'Admin',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: true
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'agent@aff.test',
            password: 'm5EcRb1tWy2000QLC@h6',
            createdAt: '2020-03-12T12:41:17.000Z',
            firstName: 'Agent',
            lastName: 'Agent',
            role: AGENT_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'guest@aff.test',
            password: 'm5EcRb1tWy2000QLC@h6',
            createdAt: '2020-03-12T12:41:17.000Z',
            firstName: 'Guest',
            lastName: 'Guest',
            role: GUEST_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u1@test.com',
            firstName: 'User',
            lastName: 'One',
            createdAt: '2019-01-10T12:41:17.000Z',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u2@test.com',
            firstName: 'User',
            lastName: 'Two',
            createdAt: '2018-02-21T12:41:17.000Z',
            role: AGENT_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u3@test.com',
            firstName: 'User',
            lastName: 'Three',
            createdAt: '2020-03-12T12:41:17.000Z',
            role: GUEST_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u4@test.com',
            firstName: 'User',
            lastName: 'Four',
            createdAt: '2021-04-27T12:41:17.000Z',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u5@test.com',
            firstName: 'User',
            lastName: 'Five',
            createdAt: '2018-05-14T12:41:17.000Z',
            role: AGENT_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u6@test.com',
            firstName: 'User',
            lastName: 'Six',
            createdAt: '2019-06-12T12:41:17.000Z',
            role: GUEST_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u7@test.com',
            firstName: 'User',
            lastName: 'Seven',
            createdAt: '2020-07-01T12:41:17.000Z',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u8@test.com',
            firstName: 'User',
            lastName: 'Eight',
            createdAt: '2018-08-12T12:41:17.000Z',
            role: AGENT_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'affogata@aff.test',
            password: 'affogata123456!',
            firstName: 'Affogata',
            lastName: 'Affogata',
            createdAt: '2022-12-10T12:41:17.000Z',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: true
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: true
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u9@test.com',
            firstName: 'User',
            lastName: 'Nine',
            createdAt: '2021-09-20T12:41:17.000Z',
            role: GUEST_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'u10@test.com',
            firstName: 'User',
            lastName: 'Ten',
            createdAt: '2019-10-11T12:41:17.000Z',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'affogataAuto@gmail.com',
            password: 'Justdoit1!',
            firstName: 'User',
            lastName: 'Eleven',
            createdAt: '2019-10-11T12:41:17.000Z',
            role: SYS_ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'affogataAuto+Admin@gmail.com',
            password: 'Justdoit1!',
            firstName: 'User',
            lastName: 'Twelve',
            createdAt: '2019-10-11T12:41:17.000Z',
            role: ADMIN_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'affogataAuto+Agent@gmail.com',
            password: 'Justdoit1!',
            firstName: 'User',
            lastName: 'Thirteen',
            createdAt: '2019-10-11T12:41:17.000Z',
            role: AGENT_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        },
        {
            email: 'affogataAuto+Guest@gmail.com',
            password: 'Justdoit1!',
            firstName: 'User',
            lastName: 'Tourteen',
            createdAt: '2019-10-11T12:41:17.000Z',
            role: GUEST_ROLE,
            preferences: {
                general: {
                    direct_email_to_network: false,
                    review_on_reply: false,
                    url_warning: false
                },
                security: {
                    two_factor_authorization: {
                        otp_enabled: false
                    }
                }
            },
            businessProfile: {
                id: 10
            }
        }
    ],

    teams: [
        {
            name: 'Social Support Team 1'
        },
        {
            name: 'Social Support Team 2'
        },
        {
            name: 'IG'
        },
        {
            name: 'Purple Team'
        },
        {
            name: 'Social Support Team 3'
        },
        {
            name: 'Social Support Team 4'
        }
    ],

    brandContexts: [
        {
            category: 'Brand 1'
        },
        {
            category: 'Brand 1',
            socialType: 7
        },
        {
            category: 'Brand 1',
            socialType: 6
        },
        {
            category: 'Brand 1',
            socialType: 5
        },
        {
            category: 'Brand 1',
            socialType: 4
        },
        {
            category: 'Brand 2'
        },
        {
            category: 'Brand 2',
            socialType: 4
        },
        {
            category: 'Brand 2',
            socialType: 3
        }
    ],

    accountContexts: [
        {
            title: 'My Search 1'
        },
        {
            title: 'My Search 2'
        },
        {
            title: 'My Search 3'
        },
        {
            title: 'My Search 4'
        },
        {
            title: 'My Search 5'
        },
        {
            title: 'My Search 6'
        }
    ],

    teamContexts: [
        {
            title: 'Team Search 1'
        },
        {
            title: 'Team Search 2'
        },
        {
            title: 'Team Search 3'
        },
        {
            title: 'Team Search 4'
        },
        {
            title: 'Team Search 5'
        }
    ],

    businessProfiles: [
        {
            name: 'PRPL',
            logo: 'https://www.prpl.io/wp-content/uploads/2019/03/cropped-Group-9-1-192x192.png',
            created_at: dateAdapter.subtract(dateAdapter(), 112, 'day')
        },
        {
            name: 'Affogata',
            logo: 'https://static.wixstatic.com/media/8c9e86_357fb4c8c9a04b1c854849a5a0f32c02~mv2.png/v1/fill/w_256,h_256,al_c/8c9e86_357fb4c8c9a04b1c854849a5a0f32c02~mv2.png',
            created_at: dateAdapter.subtract(dateAdapter(), 22, 'day')
        },
        {
            name: 'Anything 1',
            created_at: dateAdapter.subtract(dateAdapter(), 100, 'day')
        },
        {
            name: 'Something else',
            created_at: dateAdapter.subtract(dateAdapter(), 225, 'day')
        },
        {
            name: 'Some 1',
            logo: 'https://styles.redditmedia.com/t5_2s48d/styles/communityIcon_fnhvhwk39q621.png',
            created_at: dateAdapter.subtract(dateAdapter(), 30, 'day')
        },
        {
            name: 'Some 2',
            logo: 'https://logos-world.net/wp-content/uploads/2020/04/Barcelona-Logo.png',
            created_at: dateAdapter.subtract(dateAdapter(), 25, 'day')
        },
        {
            name: 'Some 3',
            created_at: dateAdapter.subtract(dateAdapter(), 12, 'day')
        }
    ],

    emails: [
        {
            articles_filter_id: 1,
            articles_limit: 20,
            articles_url: [],
            brand_name: 'any brand',
            competitors: [],
            data_from: 2,
            deliver_hour: 16,
            email_name: 'some test',
            email_type: 'executive',
            extra_emails: [],
            mail_frequency: [2, 3, 4],
            min_limitation: true,
            omit_response: true,
            posts_limit: 10,
            reciver_account_id: '2',
            search_id: null,
            business_profile_id: '1'
        },
        {
            articles_filter_id: 1,
            articles_limit: null,
            articles_url: [],
            brand_name: 'any other brand',
            competitors: [],
            data_from: 1,
            deliver_hour: 2,
            email_name: 'some more test',
            email_type: 'executive',
            extra_emails: [],
            mail_frequency: [1],
            min_limitation: true,
            omit_response: false,
            posts_limit: null,
            reciver_account_id: '1',
            search_id: null,
            business_profile_id: '4'
        }
    ],

    topics: [
        {
            name: 'Some',
            keywords: ['something', 'anything'],
            entity_type: 2,
            entity_ids: [10],
            type: 4
        },
        {
            name: 'Any other topic',
            keywords: ['different', 'subject'],
            entity_type: 2,
            entity_ids: [10],
            type: 4
        },
        {
            name: 'Anything',
            keywords: ['something', 'anything'],
            entity_type: 2,
            entity_ids: [10],
            type: 1
        },
        {
            name: 'PRPL',
            keywords: ['company', 'purple'],
            entity_type: 2,
            entity_ids: [10],
            type: 1
        },
        {
            name: 'Pioter',
            keywords: ['Pitor', 'Piotr'],
            entity_type: 2,
            entity_ids: [10],
            type: 1
        },
        {
            name: 'Football',
            keywords: ['soccer', 'football'],
            entity_type: 2,
            entity_ids: [10],
            type: 1
        },
        {
            name: 'PC Games',
            keywords: ['games', 'computer'],
            entity_type: 2,
            entity_ids: [10],
            type: 1
        }
    ],

    rules: [
        {
            name: 'Rule 1',
            entities: [
                {
                    entity_type: 2,
                    entity_id: 2
                }
            ],
            query: 'hide OR block OR "hide and block" OR hidden OR blocked',
            exclude_query: '',
            rule_type: 1,
            status_type: [1, 3],
            identities: ['@something', '@anything'],
            labelIds: ['1', '2'],
            business_profile_id: '4'
        },
        {
            name: 'Rule 2',
            entities: [
                {
                    entity_type: 2,
                    entity_id: 2
                }
            ],
            selectedGroups: [],
            query: 'hide OR block OR "hide and block" OR hidden OR blocked',
            exclude_query: ':DDD',
            rule_type: 3,
            statusType: [1, 0],
            identities: [],
            labelIds: [],
            business_profile_id: '3'
        },
        {
            name: 'Rule 3',
            entities: [
                {
                    entity_type: 2,
                    entity_id: 2
                }
            ],
            query: 'query',
            exclude_query: ':DDD',
            rule_type: 4,
            statusType: [0],
            identities: [],
            labelIds: [],
            business_profile_id: '2'
        },
        {
            name: 'Rule 4',
            ...ruleTemplate,
            business_profile_id: '1'
        },
        {
            name: 'Rule 5',
            ...ruleTemplate,
            business_profile_id: '4'
        },
        {
            name: 'Rule 6',
            ...ruleTemplate,
            business_profile_id: '5'
        },
        {
            name: 'Rule 7',
            ...ruleTemplate,
            business_profile_id: '6'
        },
        {
            name: 'Rule 8',
            ...ruleTemplate,
            business_profile_id: '2'
        },
        {
            name: 'Rule 9',
            ...ruleTemplate,
            business_profile_id: '3'
        },
        {
            name: 'Rule 10',
            ...ruleTemplate,
            business_profile_id: '7'
        },
        {
            name: 'Rule 11',
            ...ruleTemplate,
            business_profile_id: '1'
        },
        {
            name: 'Rule 12',
            ...ruleTemplate,
            business_profile_id: '1'
        },
        {
            name: 'Rule 13',
            ...ruleTemplate,
            business_profile_id: '6'
        }
    ],

    labels: [
        {
            name: 'Sports',
            category: 'Label',
            label_type: 2,
            context_id: 1,
            owner_account_id: 1,
            context_type: 3,
            created_at: 1542721350
        },
        {
            name: 'Education',
            category: 'Label',
            label_type: 3,
            context_id: 1,
            owner_account_id: 1,
            context_type: 3,
            created_at: 1542721350
        },
        {
            name: 'Biology',
            category: 'Label',
            label_type: 5,
            context_id: 1,
            owner_account_id: 1,
            context_type: 3,
            created_at: 1542721350
        }
    ],

    webhooks: [
        {
            integration_name: 'vanilla',
            uuid: '6b28c9ff-21c0-4270-81ac-2a8600c0b840'
        },
        {
            integration_name: 'zendesk',
            uuid: '3fe982de-d1d3-44d1-bfd4-8c2513e5608a'
        }
    ],

    searchFolders: [
        {
            name: 'Folder 1',
            category: 'brand'
        },
        {
            name: 'New Folder',
            category: 'brand'
        },
        {
            name: 'Some amazing search',
            category: 'team',
            pinned: true
        },
        {
            name: 'Secret folder for our team',
            category: 'team'
        },
        {
            name: 'lets take a look at this folder',
            category: 'my',
            pinned: true
        }
    ],

    searchItems: [
        {
            name: 'Search 1',
            category: 'brand',
            folderId: '2',
            pinned: true,
            logo_src:
                'https://pngset.com/images/how-to-change-your-website-name-wix-website-symbol-label-text-logo-transparent-png-2960588.png',
            query: [
                {
                    type: 'must',
                    value: [
                        {
                            filterType: 'label',
                            id: '1',
                            name: 'Sports',
                            category: 'Label',
                            label_type: 2,
                            context_id: 1,
                            owner_account_id: 1,
                            context_type: 3,
                            created_at: 1542721350
                        },
                        {
                            name: 'Some',
                            keywords: ['something', 'anything'],
                            id: '1',
                            entityType: 2,
                            entityIds: [10],
                            type: 'profiession',
                            filterType: 'topic'
                        }
                    ]
                }
            ],
            areAlertsEnabled: true
        },
        {
            name: 'search 2',
            category: 'brand',
            folderId: '2',
            logo_src:
                'https://easycommerceweb.pl/environment/cache/images/500_500_productGfx_d6cff912544d5718d9dfe8ac9eba7a53.jpg',
            query: [
                {
                    type: 'must',
                    value: [
                        {
                            name: 'Some',
                            keywords: ['something', 'anything'],
                            id: '1',
                            entityType: 2,
                            entityIds: [10],
                            type: 'profiession',
                            filterType: 'topic'
                        }
                    ]
                }
            ],
            areAlertsEnabled: false
        },
        {
            name: 'nice search',
            category: 'team',
            folderId: '3',
            areAlertsEnabled: false,
            query: []
        },
        {
            name: 'FC barcelona',
            category: 'team',
            query: [
                {
                    type: 'must-not',
                    value: [
                        {
                            filterType: 'label',
                            id: '1',
                            name: 'Sports',
                            category: 'Label',
                            label_type: 2,
                            context_id: 1,
                            owner_account_id: 1,
                            context_type: 3,
                            created_at: 1542721350
                        }
                    ]
                },
                {
                    type: 'must',
                    value: [
                        {
                            name: 'Education',
                            id: '2',
                            category: 'Label',
                            label_type: 3,
                            context_id: 1,
                            owner_account_id: 1,
                            context_type: 3,
                            created_at: 1542721350,
                            filterType: 'label'
                        }
                    ]
                }
            ],
            areAlertsEnabled: true
        },
        {
            name: 'PRPL',
            category: 'my',
            folderId: '5',
            pinned: true,
            areAlertsEnabled: false,
            query: []
        },
        {
            name: 'Search 12 acebook opinion about facebook opinio acebook opinion about facebook opinio acebook opinion about facebook opinio',
            category: 'my',
            folderId: '5',
            areAlertsEnabled: false,
            query: []
        },
        {
            name: 'something else',
            category: 'brand',
            pinned: true,
            logo_src:
                'https://play-lh.googleusercontent.com/-WtIfvZ4wG-viVEAISvuHbeHBGKq0KSWLvd4NQjWWTRMnhq4N8DTzV3WCBXqFYS9RFuY',
            areAlertsEnabled: true,
            query: []
        },
        {
            name: 'facebook opinion about facebook opinion about facebook opinion about facebook opinion about facebook opinion about',
            category: 'team',
            pinned: true,
            areAlertsEnabled: false,
            query: []
        },
        {
            name: 'lol',
            category: 'team',
            pinned: true,
            areAlertsEnabled: true,
            query: []
        },
        {
            name: 'is it working?',
            category: 'my',
            query: [
                {
                    type: 'must',
                    value: [
                        {
                            filterType: 'label',
                            id: '1',
                            name: 'Sports',
                            category: 'Label',
                            label_type: 2,
                            context_id: 1,
                            owner_account_id: 1,
                            context_type: 3,
                            created_at: 1542721350
                        },
                        {
                            name: 'Some',
                            keywords: ['something', 'anything'],
                            id: '1',
                            entityType: 2,
                            entityIds: [10],
                            type: 'profiession',
                            filterType: 'topic'
                        }
                    ]
                }
            ],
            areAlertsEnabled: false
        }
    ],

    alerts: [
        {
            name: 'simple, muted alert',
            isMuted: true,
            trigger: 'automatic',
            sendVia: 'email',
            recipientEmails: ['test@wr.ee'],
            emailDescription: '',
            thresholdCountMode: '',
            thresholdCountValue: '',
            alertTimeSpan: null,
            searchId: '7'
        }
    ],

    layers: [
        {
            name: 'API Releases',
            color: '#FA8C16',
            brand: 'A brand',
            type: 'Research'
        },
        {
            name: 'Mobile Releases',
            color: '#FADB14',
            brand: 'AAA brand',
            type: 'Community Events'
        },
        {
            name: 'Web Releases',
            color: '#1890FF',
            brand: 'AA brand',
            type: 'Research'
        },
        {
            name: 'New API changes',
            color: '#2F54EB',
            brand: 'AA brand',
            type: 'Global Events'
        },
        {
            name: 'Design updates',
            color: '#13C2C2',
            brand: 'AAA brand',
            type: 'Research'
        },
        {
            name: 'Assortment changes',
            color: '#52C41A',
            brand: 'E brand',
            type: 'PR'
        },
        {
            name: 'Personnel changes',
            color: '#EB2F96',
            brand: 'F brand',
            type: 'Community Events'
        }
    ],

    annotations: [
        {
            name: 'Release v1.02',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '1',
            datetime: '', // assigned in mock.js
            createdAt: '2022-04-10T10:41:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Topic API released',
            description: 'the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-11T09:41:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Users API changed',
            description:
                'It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-10T11:30:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Dashboard design changed!',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '4',
            createdAt: '2022-04-14T16:41:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'FB Bugfix',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '5',
            createdAt: '2022-04-18T22:41:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Release v1.03',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '1',
            createdAt: '2022-04-22T04:41:17.000Z',
            user: null
        },
        {
            name: 'S3 problems',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-15T07:41:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Sessions bug',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '4',
            createdAt: '2022-04-10T10:55:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Move to v2 version',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-12T14:11:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Release users page',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-07T06:41:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Website down for 30minutes',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-15T10:15:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'test1',
            description:
                'when an unknos, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '1',
            createdAt: '2022-04-15T10:15:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'test2',
            description:
                'when an unknos, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-17T10:15:17.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Annotations feature released',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-13T18:15:00.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'test4',
            description:
                'when an unknos, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '5',
            createdAt: '2022-04-17T10:55:55.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Duplicated topics bugfix',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-22T10:55:55.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Tests day',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-28T09:55:55.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 20minutes',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-28T12:55:00.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Removed promotional banner',
            description: 'blabla ok?',
            layerId: '4',
            createdAt: '2022-04-28T12:55:00.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 1 hour',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-28T13:55:00.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 2 hours',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-29T14:55:00.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 3 hours',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '6',
            createdAt: '2022-04-27T12:55:00.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 4 hours',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-28T10:00:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 5 hours',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-27T14:30:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'API down for 6 hours',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-28T10:20:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'Changed login page theme',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '3',
            createdAt: '2022-04-28T10:45:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'New banner',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-26T11:37:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'New game',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-25T10:10:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'New banner',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-28T10:00:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'New logo',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '7',
            createdAt: '2022-04-25T13:00:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'New welcome page',
            description:
                'when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.',
            layerId: '2',
            createdAt: '2022-04-26T14:42:01.000Z',
            user: null,
            attachments: []
        },
        {
            name: 'New CEO',
            description: 'Day when new CEO started to work at the project.',
            layerId: '6',
            createdAt: '2022-04-30T14:42:01.000Z',
            user: null,
            attachments: []
        }
    ],

    dashboardTemplates: [
        {
            name: 'Template A (1 search)',
            time: 'last-3-days',
            timeUnit: 'Days',
            config: {
                contextIds: ['1'],
                widgets: [
                    {
                        id: 'sentiment-widget',
                        config: {
                            areAnnotationsEnabled: true,
                            layerIds: ['1', '2'],
                            disabledDatasets: ['Positive']
                        }
                    },
                    {
                        id: 'network-breakdown-widget',
                        config: {
                            selectedContextId: '1',
                            activeTab: 'social',
                            disabledNetworks: ['ig', 'fb']
                        }
                    },
                    {
                        id: 'keywords-cloud-widget',
                        config: {
                            selectedSentiments: [NEUTRAL_SENTIMENT],
                            keywordTrendingChart: {
                                disabledDatasets: ['Positive', 'Neutral']
                            }
                        }
                    },
                    {
                        id: 'trending-keywords-widget',
                        config: {
                            search: 'keyword 5'
                        }
                    },
                    {
                        id: 'reviews-widget',
                        config: {
                            selectedSocialMediaFilters: [8]
                        }
                    },
                    {
                        id: 'demographics-widget',
                        config: {
                            compareModeActiveOption: TOP_LANGUAGES_OPTION
                        }
                    },
                    {
                        id: 'most-impactful-posts-widget',
                        config: {
                            selectedSocialMediaFilters: [1],
                            selectedSortOption: BY_MOST_SHARES_VALUE,
                            selectedSentiments: [NEGATIVE_SENTIMENT]
                        }
                    },
                    {
                        id: 'first-reply-time-widget',
                        config: {
                            selectedContextId: '1',
                            activeMode: 'TIME_AVERAGE_MODE',
                            disabledDatasets: ['Work SLA']
                        }
                    }
                ]
            }
        },

        {
            name: 'Template B (1 search)',
            time: 'last-7-days',
            timeUnit: 'Days',
            config: {
                contextIds: ['1'],
                widgets: [
                    {
                        id: 'sentiment-widget',
                        config: {
                            areAnnotationsEnabled: false,
                            layerIds: [],
                            disabledDatasets: ['Negative']
                        }
                    },
                    {
                        id: 'network-breakdown-widget',
                        config: {
                            selectedContextId: '1',
                            activeTab: 'ticketing',
                            disabledNetworks: []
                        }
                    },
                    {
                        id: 'keywords-cloud-widget',
                        config: {
                            selectedSentiments: [NEUTRAL_SENTIMENT, POSITIVE_SENTIMENT],
                            keywordTrendingChart: {
                                disabledDatasets: ['Neutral']
                            }
                        }
                    },
                    {
                        id: 'trending-keywords-widget',
                        config: {
                            search: ''
                        }
                    },
                    {
                        id: 'reviews-widget',
                        config: {
                            selectedSocialMediaFilters: [8]
                        }
                    },
                    {
                        id: 'demographics-widget',
                        config: {
                            compareModeActiveOption: TOP_LANGUAGES_OPTION
                        }
                    },
                    {
                        id: 'most-impactful-posts-widget',
                        config: {
                            selectedSocialMediaFilters: [1, 2, 3],
                            selectedSortOption: BY_MOST_FOLLOWERS_VALUE,
                            selectedSentiments: [NEUTRAL_SENTIMENT, POSITIVE_SENTIMENT]
                        }
                    },
                    {
                        id: 'first-reply-time-widget',
                        config: {
                            selectedContextId: '1',
                            activeMode: 'FRT_PERCENTILE_MODE',
                            disabledDatasets: []
                        }
                    }
                ]
            }
        },

        {
            name: 'Template C (2 searches)',
            time: '18/09/2022 00:00-29/09/2022 23:59',
            timeUnit: 'Months',
            config: {
                contextIds: ['1', '2'],
                widgets: [
                    {
                        id: 'impact-score-widget',
                        config: {}
                    },
                    {
                        id: 'sentiment-widget',
                        config: {
                            areAnnotationsEnabled: false,
                            layerIds: [],
                            disabledDatasets: ['Neutral', 'Negative']
                        }
                    },
                    {
                        id: 'network-breakdown-widget',
                        config: {
                            selectedContextId: '2',
                            activeTab: 'ticketing',
                            disabledNetworks: ['intercom', 'zendesk']
                        }
                    },
                    {
                        id: 'keywords-cloud-widget',
                        config: {
                            selectedSentiments: [POSITIVE_SENTIMENT],
                            keywordTrendingChart: {
                                disabledDatasets: ['Negative']
                            }
                        }
                    },
                    {
                        id: 'trending-keywords-widget',
                        config: {
                            search: '1'
                        }
                    },
                    {
                        id: 'topics-widget',
                        config: {}
                    },
                    {
                        id: 'reviews-widget',
                        config: {
                            selectedSocialMediaFilters: [20, 8]
                        }
                    },
                    {
                        id: 'demographics-widget',
                        config: {
                            compareModeActiveOption: TOP_COUNTRIES_OPTION
                        }
                    },
                    {
                        id: 'most-impactful-posts-widget',
                        config: {
                            selectedSocialMediaFilters: [2, 3],
                            selectedSortOption: BY_MOST_COMMENTS_VALUE,
                            selectedSentiments: [NEUTRAL_SENTIMENT, POSITIVE_SENTIMENT]
                        }
                    },
                    {
                        id: 'first-reply-time-widget',
                        config: {
                            selectedContextId: '2',
                            activeMode: 'FRT_PERCENTILE_MODE',
                            disabledDatasets: ['FRT Percentile']
                        }
                    }
                ]
            }
        },

        {
            name: 'Template D (3 searches)',
            time: 'last-30-days',
            timeUnit: 'Hours',
            config: {
                contextIds: ['1', '2', '3'],
                widgets: [
                    {
                        id: 'impact-score-widget',
                        config: {}
                    },
                    {
                        id: 'sentiment-widget',
                        config: {
                            areAnnotationsEnabled: false,
                            layerIds: [],
                            disabledDatasets: ['Negative']
                        }
                    },
                    {
                        id: 'network-breakdown-widget',
                        config: {
                            selectedContextId: '3',
                            activeTab: 'reviews',
                            disabledNetworks: ['ios', 'tp']
                        }
                    },
                    {
                        id: 'keywords-cloud-widget',
                        config: {
                            selectedSentiments: [NEUTRAL_SENTIMENT, POSITIVE_SENTIMENT],
                            keywordTrendingChart: {
                                disabledDatasets: ['Neutral']
                            }
                        }
                    },
                    {
                        id: 'trending-keywords-widget',
                        config: {
                            search: ''
                        }
                    },
                    {
                        id: 'topics-widget',
                        config: {}
                    },
                    {
                        id: 'reviews-widget',
                        config: {
                            selectedSocialMediaFilters: [10, 7]
                        }
                    },
                    {
                        id: 'demographics-widget',
                        config: {
                            compareModeActiveOption: TOP_LANGUAGES_OPTION
                        }
                    },
                    {
                        id: 'most-impactful-posts-widget',
                        config: {
                            selectedSocialMediaFilters: [4, 5],
                            selectedSortOption: BY_TOTAL_ENGAGEMENT_VALUE,
                            selectedSentiments: [NEUTRAL_SENTIMENT, NEGATIVE_SENTIMENT]
                        }
                    },
                    {
                        id: 'first-reply-time-widget',
                        config: {
                            selectedContextId: '3',
                            activeMode: 'TIME_AVERAGE_MODE',
                            disabledDatasets: ['Avg. SLA']
                        }
                    }
                ]
            }
        }
    ],

    excludeTerms: [
        {
            businessProfileId: 1,
            exclude_terms: {
                hello: 'goodbye'
            },
            languages: ['en', 'fr'],
            social_types: [1, 2, 3]
        },
        {
            businessProfileId: null,
            exclude_terms: {
                shoot: null
            },
            languages: [],
            social_types: []
        }
    ]
};
